import { ICurrencyList } from './../../../../hooks/useCurrencies';
import { IBundleConsituent } from './../../../../entities/cdn';
import { IBundle } from 'entities/cdn';

// portfolio API data to Victory pie data
export const mapBundleConstituentsToPie = (data: IBundle | undefined, currenciesList: ICurrencyList) => {
    console.log('mapBundle', data?.Assets)
    const result = data?.Assets?.map?.((constituent: IBundleConsituent) => ({
        x: constituent.Code,
        y: Number(constituent.CurrentWeight),
        color: currenciesList?.[constituent?.Code]?.colors.primary
    }))
    return result
}